/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Min_Event_Lines_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum Event Lines" |
*
* @param {Style_Guide_Manager_Min_Event_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_min_event_lines_label = /** @type {((inputs?: Style_Guide_Manager_Min_Event_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Min_Event_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lignes minimum par evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestanzahl an Ereigniszeilen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Linee di eventi minimi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальное количество линий событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Líneas mínimas de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最低事件线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小イベントライン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम घटना रेखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linhas mínimas de eventos")
	return /** @type {LocalizedString} */ ("Minimum Event Lines")
});